import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { CSSTransition } from 'react-transition-group'
import classNames from 'classnames'

import { BaseButton } from 'components/button'

import styles from './hint_tooltip.scss'

const arrowPosition = {
	'top-left': 'top-left',
	'top-center': 'top-center',
	'top-right': 'top-right',
	'right-top': 'right-top',
	'right-center': 'right-center',
	'right-bottom': 'right-bottom',
	'bottom-right': 'bottom-right',
	'bottom-center': 'bottom-center',
	'bottom-left': 'bottom-left',
	'left-bottom': 'left-bottom',
	'left-center': 'left-center',
	'left-top': 'left-top',
}

class HintTooltip extends Component {

	render() {
		return (
			<CSSTransition
				in
				appear
				classNames={{
					appear: styles.appear,
				}}
				timeout={3200}
			>
				<div styleName={classNames({
					hint: true,
					[arrowPosition[this.props.arrowPosition]]: true,
					'hint--animated-content': this.props.animatedContent,
				})}>
					<div styleName='hint-content'>
						{ !!this.props.headerImage &&
							<img
								src={this.props.headerImage}
								alt=''
								styleName='hint-header-image'
							/>
						}
						<p styleName={classNames({
							'hint-text': true,
							'hint-text--centered': this.props.centeredContent,
							'hint-text--with-margin': !this.props.shouldShowButton,
						})}>
							{this.props.hintText}
						</p>
						{ this.props.shouldShowButton &&
							<div styleName={classNames({
								'btn-container': true,
								'btn-container--centered': this.props.centeredContent,
							})}>
								<div styleName='hint-button'>
									<BaseButton
										size='small'
										bgColor='fullWhite'
										fontColor='blue'
										onClick={this.props.onButtonClick}
									>
										{this.props.hintButton}
									</BaseButton>
								</div>
							</div>
						}
					</div>
				</div>
			</CSSTransition>
		)
	}
}

HintTooltip.propTypes = {
	arrowPosition: PropTypes.string,
	hintText: PropTypes.string,
	hintButton: PropTypes.string,
	centeredContent: PropTypes.bool,
	headerImage: PropTypes.string,
	onButtonClick: PropTypes.func,
	animatedContent: PropTypes.bool,
	shouldShowButton: PropTypes.bool,
}

HintTooltip.defaultProps = {
	arrowPosition: 'top-left',
	centeredContent: false,
	onButtonClick: () => {},
	headerImage: '',
	animatedContent: false,
	shouldShowButton: true,
}

export default CSSModules(HintTooltip, styles, {allowMultiple: true})
